import * as types from '@/store/types'
import {REQUEST_STATUS} from '@/store/utils/request-status'
import {getNextCandidate} from '@/api/candidate'

const state = {
  // Keep track of candidates used in a session. Useful to filter candidates created by the API
  // by those distinct from what the user has already seen in the current session.
  prevItems: [],
  item: {
    candidateId: null,
    imageKey: 0,
    usnoBand: 'red1',
    panstarrBand: 'r',
    v: null
  },
  status: REQUEST_STATUS.NONE
}

const actions = {
  setNextCandidate({commit}, imageKey) {
    commit(types.CANDIDATE__SET, Number(imageKey))
  },
  async getNextCandidate ({commit, state, rootState}) {
    commit(types.CANDIDATE__GET_INIT)
    try {
      const {data} = await getNextCandidate(rootState.nextCandidate, state.prevItems.map(x => x.imageKey))
      commit(types.CANDIDATE__GET_SUCCESS, data)
    } catch (err) {
      const errors = err.response ? err.response.data : err
      commit(types.CANDIDATE__GET_FAILURE, errors)
    }
  }
}

const mutations = {
  [types.CANDIDATE__SET] (state, imageKey) {
    state.item = {
      ...state.item,
      candidateId: null,
      v: null,
      imageKey
    }
    state.status = REQUEST_STATUS.NONE
  },
  [types.CANDIDATE__GET_INIT] (state) {
    // Keep track of the previous candidate shown to the user
    state.prevItems = state.prevItems.concat(state.item)

    state.status = REQUEST_STATUS.GET
  },
  [types.CANDIDATE__GET_SUCCESS] (state, data) {
    // Update next candidate
    state.item = {
      candidateId: data['_id'],
      imageKey: data['image_key'],
      usnoBand: data['usno_band'],
      panstarrBand: data['panstarr_band'],
      v: data['v'] || null
    }

    state.status = REQUEST_STATUS.NONE
  },
  [types.CANDIDATE__GET_FAILURE] (state, errors) {
    state.status = REQUEST_STATUS.NONE
    console.error(errors)
  }
}

export default {
  state,
  actions,
  mutations
}
